/* This file is based on `vscode-lean4/vscode-lean4/src/abbreviation/AbbreviationHoverProvider.ts` */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { config } from './config';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
/**
 * Adds hover behaviour for getting translations of unicode characters.
 * Eg: "Type ⊓ using \glb or \sqcap"
 */
var AbbreviationHoverProvider = /** @class */ (function () {
    function AbbreviationHoverProvider(abbreviations) {
        this.abbreviations = abbreviations;
    }
    AbbreviationHoverProvider.prototype.provideHover = function (model, pos) {
        var _this = this;
        var context = model.getLineContent(pos.lineNumber).substring(pos.column - 1);
        var symbolsAtCursor = this.abbreviations.findSymbolsIn(context);
        var allAbbrevs = symbolsAtCursor.map(function (symbol) { return ({
            symbol: symbol,
            abbrevs: _this.abbreviations.getAllAbbreviations(symbol),
        }); });
        if (allAbbrevs.length === 0 ||
            allAbbrevs.every(function (a) { return a.abbrevs.length === 0; })) {
            return undefined;
        }
        var leader = config.abbreviationCharacter;
        var hoverMarkdown = allAbbrevs
            .map(function (_a) {
            var symbol = _a.symbol, abbrevs = _a.abbrevs;
            return "Type ".concat(symbol, " using ").concat(abbrevs
                .map(function (a) { return '`' + leader + a + '`'; })
                .join(' or '));
        })
            .join('\n\n');
        var maxSymbolLength = Math.max.apply(Math, __spreadArray([], __read(allAbbrevs.map(function (a) { return a.symbol.length; })), false));
        var hoverRange = new monaco.Range(pos.lineNumber, pos.column - 1, pos.lineNumber, pos.column - 1 + maxSymbolLength);
        return { contents: [{ value: hoverMarkdown }], range: hoverRange };
    };
    return AbbreviationHoverProvider;
}());
export { AbbreviationHoverProvider };
